const formatPaymentMethod = (value) => {
  const methods = {
    cash: "Contado",
    card: "Tarjeta",
    transfer: "Transferencia",
    credit: "Crédito",
  };

  return methods[value] || "Contado";
};

const calculateTerm = (issueDate, dueDate) => {
  if (!dueDate) return "Contado";

  const issue = new Date(issueDate);
  const due = new Date(dueDate);

  if (Number.isNaN(issue.getTime()) || Number.isNaN(due.getTime())) {
    return "-";
  }

  const difference = Math.round(
    (due.getTime() - issue.getTime()) / (1000 * 60 * 60 * 24)
  );

  return difference <= 0 ? "Contado" : `${difference} días`;
};

export default function InvoiceAdditionalInfo({ invoice }) {
  if (!invoice) return null;

  return (
    <section className="invoice-additional-layout">
      <div className="invoice-additional-info">
        <div className="invoice-observations">
          <h4>Observaciones</h4>

          <p>
            {invoice.notes?.trim() || "Sin observaciones."}
          </p>
        </div>

        <div className="invoice-payment-info">
          <div className="invoice-info-box">
            <span>Forma de pago</span>
            <strong>
              {formatPaymentMethod(invoice.payment_method)}
            </strong>
          </div>

          <div className="invoice-info-box">
            <span>Plazo</span>
            <strong>
              {calculateTerm(
                invoice.issue_date,
                invoice.due_date
              )}
            </strong>
          </div>
        </div>

        <div className="invoice-system-footer">
          <strong>NetLedger ERP</strong>
          <span>Documento generado automáticamente.</span>
          <span>Preparado para Facturación Electrónica DIAN.</span>
        </div>
      </div>

      <aside className="invoice-dian-qr">
        <div className="invoice-qr-box">
          {invoice.qr_url || invoice.qr_data_url ? (
            <img
              src={invoice.qr_url || invoice.qr_data_url}
              alt="Código QR DIAN"
              className="invoice-qr-image"
            />
          ) : (
            <div className="invoice-qr-placeholder">
              QR
            </div>
          )}
        </div>

        <strong>QR DIAN</strong>

        <span>
          Código QR de validación electrónica
        </span>

        <div className="invoice-cufe-box">
          <small>CUFE</small>

          <p>
            {invoice.cufe || "Disponible al generar la factura electrónica"}
          </p>
        </div>
      </aside>
    </section>
  );
}